import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import WithReAuth from 'two-factor-prompt-lib/containers/WithReAuth';
import EditEmailAddressModalContainer from '../containers/EditEmailAddressModalContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditEmailAddress = ({
  onEditEmailAddress,
  isScimUser,
  currentEmail
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(WithReAuth, {
      onSuccess: onEditEmailAddress,
      isDisabled: isScimUser,
      email: currentEmail,
      skipVerificationIfNotSet: true,
      children: /*#__PURE__*/_jsx(UITooltip, {
        title: isScimUser && /*#__PURE__*/_jsx(FormattedMessage, {
          message: "userPreferences.errors.notAllowedToEditScimUser"
        }),
        children: /*#__PURE__*/_jsx(UIButton, {
          className: "m-top-2",
          use: "tertiary-light",
          size: "small",
          disabled: isScimUser,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "userPreferences.labels.edit"
          })
        })
      })
    }), /*#__PURE__*/_jsx(EditEmailAddressModalContainer, {})]
  });
};
EditEmailAddress.propTypes = {
  onEditEmailAddress: PropTypes.func.isRequired,
  isScimUser: PropTypes.bool.isRequired,
  currentEmail: PropTypes.string.isRequired
};
export default EditEmailAddress;